import Alerts from './ModalAlerts.vue';

export default Alerts;
